import React from 'react';
import { jsonForm } from '@europrocurement/flexy-form/utils/types/formTypes';
import { AccordionJsonForms, DossierFormulaire } from '@europrocurement/l2d-modules';
import { Scrollbar } from '@europrocurement/flexy-components';
import { Box } from '@mui/material';

export type DossierFormsBodyProps = {
    formulaire: DossierFormulaire;
    onChange: (data: Record<string, unknown>) => void;
};

const DossierFormsBody: React.FunctionComponent<DossierFormsBodyProps> = function (props) {
    const { formulaire, onChange: handleChange } = props;
    const divRef = React.useRef<HTMLDivElement>(null);

    if (!formulaire.formulaireJson) {
        return null;
    }

    return (
        <Box
            sx={{ height: '85%', width: '100%' }}
            ref={divRef}
        >
            <Box
                sx={{
                    width: divRef.current ? Math.round(divRef.current?.clientWidth) - 1 : '100%',
                    height: '100%',
                }}
            >
                <Scrollbar>
                    <AccordionJsonForms
                        json={formulaire.formulaireJson as jsonForm}
                        defaultValues={formulaire.prestationJson as Record<string, unknown>}
                        formulaireId={formulaire.formulaireId as number}
                        formaliteId={formulaire.formaliteId}
                        visibility="BACK"
                        expanded
                        onChange={handleChange}
                    />
                </Scrollbar>
            </Box>
        </Box>
    );
};

export default DossierFormsBody;
